export type TComplaintsSection = {
  key: string;
  paragraphs?: readonly string[];
  bullets?: readonly string[];
};

export const COMPLAINTS_SECTIONS: readonly TComplaintsSection[] = [
  {
    key: 'liability',
    paragraphs: ['line1'],
  },
  {
    key: 'customer.may',
    paragraphs: ['line1'],
    bullets: ['item1', 'item2', 'item3', 'item4'],
  },
  {
    key: 'complaint.must.include',
    paragraphs: ['line1'],
    bullets: ['item1', 'item2', 'item3'],
  },
  {
    key: 'processing.time',
    paragraphs: ['line1'],
  },
] as const;
